import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { baseUrl } from "../../common/constants";
import "./style.css";
import companyLogo from "./images/logo.png";
import { toast } from "react-toastify";
import Loading from "../../components/Loader/Loading";
import { formatAddress, formatTo12Hour } from "../../components/ReusableComponent/Common";
import  _axios   from "../../utils/api/_axios";
import { Button } from "antd";
import moment from "moment";


const AppointmentPdf = () => {
  const { patientId, claimId } = useParams();
  const [claim, setClaim] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [formValues, setFormValues] = useState({
    claimantName: "",
    dateOfBirth: "",
    dateOfInjury: "",
    patientAddress: "",
    claimNumber: "",
    wcbNumber: "",
    patientUniqueId: "",
    claimUniqueId: "",
    requestedTest: "",
    insuranceCompanyName: "",
    adjusterName: "", 
    referrer: "", 
    visitDate: "",
    visitTime: "",
    doctorName: "",
    officeName: "",
    adjusterPhoneNumber: "",
    contactPerson: "",
    contactPersonPhone: "",
    doctor: {
      doctorAddress: {},
      doctorPhone: "",
      doctorFax: "",
    },
    officeDetails: {
      officeAddress: "",
      officePhone: "",
      officeFax: "",
    },
  });

  const fetchClaim = async () => {
    try {
      const response = await _axios.get(
        `${baseUrl}/dashboard/report/patient/${patientId}/claim/${claimId}`
      );
      const payload = response.data.payload[0];
        setIsLoading(false);
        setValues(payload);
    } catch (error) {
      console.error("Error fetching claims:", error);
      toast.error(error.message);
    }
  };

  const getFormattedProcedureNames = (procedures) => {
    return procedures
      ?.map((procedure, index) => procedure.procedure)
      .filter(Boolean)
      .join(', ');
  };

  const getOfficeAddressDetails = (appointment) => {
    const { officeAddress } = appointment;
  
    const matchingAddress = officeAddress;
  
    if (matchingAddress) {
      const { address, phone, fax } = matchingAddress;
      const officeAddress = address;
      return {
        officeAddress: officeAddress,
        officePhone: phone,
        officeFax: fax || "",
      };
    } else {
      return {
        officeAddress: "",
        officePhone: "",
        officeFax: "",
      };
    }
  };

  const setValues = (payload) => {
    const formattedProcedureNames = getFormattedProcedureNames(payload.procedures);
    const patientAddressValue = formatAddress(payload?.patientDetails?.patient_address1, payload?.patientDetails?.patient_address2, payload?.patientDetails?.patient_city, payload?.patientDetails?.patient_state, payload?.patientDetails?.patient_zip, true);
    const doctorAddressValue = formatAddress(payload?.adjusterInfo?.referringDoctor?.referred_address1, payload?.adjusterInfo?.referringDoctor?.referred_address2, payload?.adjusterInfo?.referringDoctor?.referred_city, payload?.adjusterInfo?.referringDoctor?.referred_state, payload?.adjusterInfo?.referringDoctor?.referred_zip, true);

    setFormValues({
        ...formValues,
        claimantName: `${payload?.patientDetails?.firstName} ${payload?.patientDetails?.lastName}`,
        dateOfBirth: new Date(payload?.patientDetails?.dateOfBirth)
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
        dateOfInjury: new Date(payload?.dateOfInjury)
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
        patientAddress: patientAddressValue,
        claimNumber: payload?.claimNumber,
        claimUniqueId:payload?.claimUniqueId,
        wcbNumber: payload?.wcbNumber,
        patientUniqueId: payload?.patientDetails?.patientUniqueId,
        requestedTest: formattedProcedureNames,
        insuranceCompanyName: payload?.adjusterInfo?.companyName,
        adjusterName: `${payload?.adjusterInfo?.firstName} ${payload?.adjusterInfo?.lastName}`, 
        visitDate: moment(payload?.appointment?.visitDate).format("DD/MM/YYYY"),
        visitTime: formatTo12Hour(payload?.appointment?.visitTime),
        doctorName: payload?.appointment?.doctorName,
        officeName: payload?.appointment?.officeName,
        adjusterPhoneNumber: payload?.adjusterInfo?.phone,
        contactPerson: payload?.appointment?.contactPerson,
        contactPersonPhone: payload?.appointment?.contactPersonPhone,
        doctor: {
          referringDoctor: `${payload?.adjusterInfo?.referringDoctor?.firstName} ${payload?.adjusterInfo?.referringDoctor?.lastName}`,
          doctorAddress: doctorAddressValue,
          doctorPhone: payload?.adjusterInfo?.referringDoctor?.phone,
          doctorFax: payload?.adjusterInfo?.referringDoctor?.fax,
          nurseCaseManager: payload?.adjusterInfo?.referringDoctor?.nurseCaseManager,
        },
        officeDetails: getOfficeAddressDetails(payload?.appointment),
    });
  }


  useEffect(() => {
    fetchClaim()
  }, []);
  return (
    <>
      {isLoading && (
        <div className="circularLoader">
        <Loading isCircular={true} />
        </div>
      )}
      {
        <div className="apt-letter">
            <div className="container">
              <form method="post">
                <div id="appointment">
                  <hr className="topHr" />
                  <div className="contact">
                    <div className="CompanyInfoBox">
                      <img id="companyLogo" src={companyLogo} />
                      <div className="right">
                        <p>Right Script Services</p>
                        <p>Po Box 1225</p>
                        <p>Webster NY 14580</p>
                        <p>585-738-8317m</p>
                      </div>
                    </div>
                    <br />
                    <br />
                    <div className="formGrid">
                      <div>
                        <div>
                          <label className="left">Claimant Name:</label>
                          <span className="left2">
                            <input type="text" value={formValues?.claimantName} readOnly/>
                          </span>
                        </div>
                        <div>
                          <label className="left">Address:</label>
                          <span className="left2">
                            <input type="text" value={formValues.patientAddress.address}/>
                            <input type="text" value={formValues.patientAddress.cityStateZip} />
                          </span>
                        </div>
                        <div>
                          <label className="left">DOB:</label>
                          <span className="left2">
                            <input type="text" value={formValues.dateOfBirth} readOnly/>
                          </span>
                        </div>
                      </div>
                      <div>
                        <div>
                          <label className="left">DOI:</label>
                          <span className="left2">
                            <input type="text" value={formValues.dateOfInjury} readOnly/>
                          </span>
                        </div>
                        <div>
                          <label className="left">WCB#:</label>
                          <span className="left2">
                            <input type="text" value={formValues.wcbNumber} readOnly/>
                          </span>
                        </div>
                        <div>
                          <label className="left">RSS#:</label>
                          <span className="left2">
                            <input type="text" value={formValues.patientUniqueId} readOnly/>
                          </span>
                        </div>
                        <div>
                          <label className="left">RSS-RF#:</label>
                          <span className="left2">
                            <input type="text" value={formValues.claimUniqueId} readOnly/>
                          </span>
                        </div>
                      </div>
                    </div>
                    <br />
                    <br />
                    <article>
                      Dear Claimant,
                      <br />
                      This notice is to confrm your upcoming diagnostic test.
                      Please see below for details of appointment.
                      <br />
                      <br />
                    </article>
                    <div>
                      <strong className="left">Requested Test:</strong>
                      <span className="left2">
                        <input type="text" value={formValues.requestedTest} readOnly/>
                      </span>
                    </div>
                    <br />
                    <div className="formGrid">
                      <div>
                        <div>
                          <label className="left">Appointment Date:</label>
                          <span className="left2">
                            <input type="text" value={formValues.visitDate} readOnly/>
                          </span>
                        </div>
                        <div>
                          <label className="left">Appointment Time:</label>
                          <span className="left2">
                            <input type="text" value={formValues.visitTime} readOnly/>
                          </span>
                        </div>
                        <div>
                          <label className="left">Provider/Facility:</label>
                          <span className="left2">
                            <input type="text" value={formValues.contactPerson} readOnly/>
                          </span>
                        </div>
                        <div>
                          <label className="left">Address:</label>
                          <span className="left2">
                            <input type="text" value={formValues.officeDetails.officeAddress} readOnly/>
                            <input type="text" value={formValues.officeDetails.cityStateZip} readOnly/>
                          </span>
                          {/* <span className="left2">
                            <input type="text" />
                          </span> */}
                        </div>
                        <div>
                          <label className="left">Phone:</label>
                          <span className="left2">
                            <input type="text" value={formValues.contactPersonPhone} readOnly/>
                          </span>
                        </div>
                        {formValues?.officeDetails?.officeFax?.length > 0 &&
                          <div>
                          <label className="left">Fax:</label>
                          <span className="left2">
                            <input type="text" value={formValues?.officeDetails?.officeFax} readOnly/>
                          </span>
                        </div>
                        }
                      </div>
                      <div>
                        <div>
                          <label className="left">Referring Doctor:</label>
                          <span className="left2">
                            <input type="text" value={formValues.doctor.referringDoctor} readOnly/>
                          </span>
                        </div>
                        <div>
                          <label className="left">Address:</label>
                          <span className="left2">
                            <input type="text" value={formValues.doctor.doctorAddress.address} readOnly/>
                            <input type="text" value={formValues.doctor.doctorAddress.cityStateZip} readOnly/>
                          </span>
                        </div>
                        <div>
                          <label className="left">Phone:</label>
                          <span className="left2">
                            <input type="text" value={formValues.doctor.doctorPhone} readOnly/>
                          </span>
                        </div>
                        {formValues?.doctor?.doctorFax?.length > 0 &&
                        <div>
                          <label className="left">Fax:</label>
                          <span className="left2">
                            <input type="text" value={formValues.doctor.doctorFax} readOnly/>
                          </span>
                        </div>
        }
                      </div>
                    </div>
                    <br />
                    <div>
                      <div>
                        <label className="left">Insurance Company:</label>
                        <span className="left2">
                          <input type="text" value={formValues.insuranceCompanyName} readOnly/>
                        </span>
                      </div>
                      <div>
                        <label className="left">Adjuster:</label>
                        <span className="left2">
                          <input type="text" value={formValues.adjusterName} readOnly/>
                        </span>
                      </div>
                      {formValues.adjusterPhoneNumber &&
                        <div>
                        <label className="left">Adjuster Phone Number</label>
                        <span className="left2">
                          <input type="text" value={formValues.adjusterPhoneNumber} readOnly/>
                        </span>
                      </div>
                      }
                      <div>
                        <label className="left">Nurse case Manager:</label>
                        <span className="left2">
                          <input type="text" value={formValues?.doctor?.nurseCaseManager || ""} readOnly/>
                        </span>
                      </div>
                    </div>
                    <br />
                    <br />
                    <div className="informationBox">
                      <div className="infoGroup">
                        <div className="infoHeading">
                          IMPORTANT INFORMATION TO BE AWARE OF PRIOR TO
                          APPOINTMENT
                        </div>
                        <ul className="infoList">
                          <li>Please bring Photo I.D.</li>
                          <li>
                            Arrive 15 minutes prior to scheduled appointment
                          </li>
                          <li>
                            If you need to cancel this appointment, please contact
                            adjuster within 24 hours of receiving this notice
                          </li>
                          <li>
                            Please be advised that you may be asked to remove any
                            jewellery for a specific test
                          </li>
                          <li>
                            Please be advised that you may be asked to remove
                            contacts for a vision inpairment for a specific test.
                          </li>
                          <li>
                            Please be advised if you have any metal within your
                            body when asked for a specific test
                          </li>
                        </ul>
                      </div>
                    </div>
                    Regards,
                    <br />
                    <br />
                    Right Script Services
                    <br />
                    <br />
                    <br />
                    <hr className="bottomHr" />
                    <br />
                    <br />
                  </div>
                </div>
              </form>
        </div>
        <div className="button-container">
              <Button type="primary" variant="contained" className="print-button" onClick={() => window.print()}>
                Print
              </Button>
        </div>
        </div>
      }
    </>
  );
};

export default AppointmentPdf;